<script>
import { common } from "@/mixins/common";
import moment from "moment-timezone";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "GlobalSearchProductResults",
  components: {
    VLazyImage,
  },
  props: {
    results: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pagination: {
        page_size: 50,
        total: 1,
        page: 1,
      },
      tableData: [],
      columns: [
        {
          key: "id",
          value: "ID",
          sortable: false,
        },
        {
          key: "picture",
          value: "Pictures",
          sortable: false,
        },
        {
          key: "title",
          value: "Title",
          sortable: false,
          center: true,
        },
        {
          key: "actions",
          value: "Actions",
          sortable: false,
          center: true,
        },
      ],
      searchQuery: "",
      selectedAction: {
        actionName: "",
        productId: 0,
      },
    };
  },
  mixins: [common],
  methods: {
    searchProduct() {
      this.$root.$emit("searchProduct", this.searchQuery);
    },
    getFormattedData(timestamp) {
      return moment(timestamp * 1000).format("YYYY-MM-DD h:mm a");
    },
    getCurrentStatus(statusCode) {
      return this.getStatus(statusCode, "text").toLowerCase();
    },
    /**
     * Display Dialog to confirm before proceed to an action
     * @param actionName
     * @param productId
     */
    callProceedActionDialog(actionName, productId) {
      this.selectedAction = { actionName, productId };
      //this.showConfirmCallActionDialog = true;
      this.$root.$emit("displayProceedActionDialog", {
        display: true,
        actionName,
        productId,
      });
    },
    /**
     * Ability to call another method from its
     * @param _params
     */
    //proceedAction (_params) {}
  },
  computed: {
    ebayStoreUrl() {
      return process.env.NODE_ENV === "development"
        ? "http://sandbox.ebay.com"
        : "http://ebay.com";
    },
  },
  mounted() {
    const _vm = this;
    _vm.searchQuery = _vm.query;
    //
    _vm.$root.$on("proceedActionDialog", (params) => {
      _vm[params.actionName](params.productId).then((res) => {
        // eslint-disable-next-line
        //console.log(JSON.stringify(res));
        window.location.href =
          "/products/index?tab=" +
          _vm.getStatus(res.data.status, "value") +
          "&id=" +
          res.data.id;
        // eslint-disable-next-line
        console.log(res);
        _vm.searchProduct();
      });
    });
  },
  watch: {
    query: function () {
      this.searchQuery = this.query;
    },
  },
};
</script>

<template>
  <div class="products__list_content search_product_list">
    <!-- App Search-->
    <form class="app-search d-none d-lg-block" @submit.prevent="searchProduct()">
      <div class="position-relative">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control"
          size="40"
          :placeholder="$t('navbar.topSearch.text')"
        />
        <el-button
          :disabled="searchQuery.length < 2"
          icon="el-icon-search"
          type="primary"
          size="small"
          native-type="submit"
          circle
        ></el-button>
      </div>
    </form>
    <div class="table-responsive">
      <table role="table" aria-busy="false" aria-colcount="10" class="table b-table">
        <thead role="rowgroup" class="" style="background-color: #74788d; color: white">
          <tr role="row" class="">
            <th
              role="columnheader"
              scope="col"
              aria-colindex="1"
              :class="[column.center ? 'text-center' : '', 'px-4']"
              v-for="column in columns"
              :key="column.key"
            >
              <div>{{ column.value }}</div>
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <tr
            role="row"
            aria-rowindex="1"
            class=""
            v-for="data in results"
            :key="data.id"
          >
            <td aria-colindex="1" role="cell" style="font-size: 14px" class="col-sm">
              <div class="">{{ data.id }}</div>
              <div class="font-weight-bold" style="color: rgb(0, 136, 204)">
                {{ data.barcode }}
              </div>
              <el-tooltip class="item mb-1" effect="dark" content="BIN#" placement="left">
                <span class="font-weight-bold" style="color: #f46a6a">
                  B {{ data.binId == 0 ? "..." : data.binId }}
                </span>
              </el-tooltip>
              <div class="">
                <span
                  class="badge badge-pill font-size-14 badge-soft-success"
                  v-if="data.AuctionOwner"
                >
                  {{ data.AuctionOwner.displayName }}
                </span>
              </div>
            </td>
            <td aria-colindex="1" role="cell" style="font-size: 14px" class="col-sm">
              <div
                class=""
                @click="loadProductPictures(data.id, data.AuctionAttachments.length)"
              >
                <v-lazy-image
                  class="d-block w-100 img-thumbnail img-thumbnail-100"
                  :src="data.AuctionAttachments[0].thumbnailUrl"
                  v-bind:src-placeholder="
                    require('@/assets/images/image-lazy-loading.gif')
                  "
                  v-if="data.AuctionAttachments.length > 0"
                />
                <span v-else>No Picture available</span>
              </div>
            </td>
            <td aria-colindex="1" role="cell" style="font-size: 14px" class="col-sm">
              <div :class="['font-weight-bold', 'single-product-title']">
                {{ data.title }}
              </div>
              <div class="">
                <span
                  class="badge badge-pill font-size-12 badge-soft-danger"
                  style="margin-right: 5px"
                  v-if="data.parameters.storeCategoryName1"
                >
                  {{ data.parameters.storeCategoryName1 }}
                </span>
                <span
                  class="badge badge-pill font-size-12 badge-soft-danger"
                  v-if="data.parameters.storeCategoryName2"
                >
                  {{ data.parameters.storeCategoryName2 }}
                </span>
              </div>
              <div
                class="product-description"
                v-if="data.parameters.description"
                v-html="data.parameters.description.trim()"
                style="white-space: pre-line"
              ></div>
              <div class="font-size-15">
                <span class="font-weight-bold">Creation Date:</span>
                {{ getFormattedData(data.createdOn) }}
              </div>
              <div v-if="data.ebayId > 0" class="mt-1 font-size-15">
                <strong>Ebay ID:</strong>
                <a :href="ebayStoreUrl + '/itm/' + data.ebayId" target="_NEW">
                  {{ data.ebayId }}
                </a>
              </div>
              <div v-if="data.oldBinId > 0" class="mt-1 font-size-15">
                <strong>Latest BIN ID:</strong> {{ data.oldBinId }}
              </div>
              <div v-if="data.numTimesRelisted > 0" class="mt-1 font-size-15">
                This item have been relisted
                <strong>{{ data.numTimesRelisted }}</strong> time{{
                  data.numTimesRelisted > 1 ? "s" : ""
                }}
              </div>
              <div class="">
                <el-tag
                  type="success"
                  size="mini"
                  effect="dark"
                  :style="{
                    color: 'white',
                    backgroundColor: getStatus(data.status, 'bgColor'),
                    borderColor: getStatus(data.status, 'borderColor'),
                  }"
                  v-if="data.status != 10 || !data.archived"
                >
                  {{ getStatus(data.status, "text") }}
                </el-tag>
                <el-tag
                  type="success"
                  size="mini"
                  effect="dark"
                  :style="{
                    color: 'white',
                    backgroundColor: getStatus(10, 'bgColor'),
                    borderColor: getStatus(10, 'borderColor'),
                  }"
                  v-else
                >
                  Archived
                </el-tag>
              </div>
            </td>
            <td aria-colindex="2" role="cell" :class="['text-center', 'px-0', 'col-sm']">
              <!-- Edit Product Button -->
              <div class="mb-1">
                <a
                  :href="'/products/edit/' + data.id"
                  class="btn btn-warning btn-sm px-3"
                  target="_blank"
                  title="Edit Product"
                >
                  <i class="fas fa-edit"></i>
                </a>
              </div>
              <!-- Product tools Button -->
              <b-dropdown
                :dropleft="true"
                variant="secondary"
                v-if="!hasToolsDropdownStatus(getCurrentStatus(data.status))"
              >
                <template slot="button-content">
                  <i class="fas fa-cog"></i>
                  <i class="mdi mdi-chevron-down"></i>
                </template>
                <b-dropdown-item
                  v-if="hasMarkPresetStatus(getCurrentStatus(data.status))"
                  variant="primary"
                  @click="callProceedActionDialog('makePreset', data.id)"
                >
                  <i class="fab fa-pagelines"></i>&nbsp;&nbsp;&nbsp;Make Preset
                </b-dropdown-item>
                <b-dropdown-item
                  variant="warning"
                  v-if="getCurrentStatus(data.status) == 'ready'"
                  @click="callProceedActionDialog('readyRevert', data.id)"
                >
                  <i class="fas fa-undo"></i>&nbsp;&nbsp;&nbsp;Revert
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="hasMarkReadStatus(getCurrentStatus(data.status))"
                  @click="callProceedActionDialog('markReady', data.id)"
                >
                  <i class="fas fa-check-double"></i>&nbsp;&nbsp;&nbsp;Send To Ready
                </b-dropdown-item>
                <b-dropdown-item
                  @click="callProceedActionDialog('loadPreviewTemplate', data.id)"
                  v-if="hasPreviewTemplateStatus(getCurrentStatus(data.status))"
                >
                  <i class="fas fa-eye"></i>&nbsp;&nbsp;&nbsp;Preview
                </b-dropdown-item>
                <b-dropdown-item
                  @click="callProceedActionDialog('sendToReview', data.id)"
                  v-if="hasSendToReviewStatus(getCurrentStatus(data.status))"
                >
                  <i class="fas fa-search-dollar"></i>&nbsp;&nbsp;&nbsp;Send To Review
                </b-dropdown-item>
                <b-dropdown-item
                  variant="danger"
                  @click="callProceedActionDialog('sendToRelist', data.id)"
                  v-if="hasSendToRelistStatus(getCurrentStatus(data.status))"
                >
                  <i class="fas fa-undo"></i>&nbsp;&nbsp;&nbsp;Send To Relist
                </b-dropdown-item>
                <b-dropdown-item
                  variant="warning"
                  @click="callProceedActionDialog('sendToFlagged', data.id)"
                  v-if="hasSendToFlaggedStatus(getCurrentStatus(data.status))"
                >
                  <i class="fas fa-sticky-note"></i>&nbsp;&nbsp;&nbsp;Send To flagged
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="hasForceSubmitStatus(getCurrentStatus(data.status))"
                  @click="callProceedActionDialog('forceSubmit', data.id)"
                >
                  <i class="fas fa-share-square"></i>&nbsp;&nbsp;&nbsp;Force Submit
                </b-dropdown-item>
                <b-dropdown-item
                  @click="callProceedActionDialog('archiveProduct', data.id)"
                  v-if="hasArchiveStatus(getCurrentStatus(data.status))"
                >
                  <i class="fas fa-trash-alt"></i>&nbsp;&nbsp;&nbsp;Archive
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="hasShareToSocialMediaStatus(getCurrentStatus(data.status))"
                  @click="callProceedActionDialog('shareToSocialMedia', data.id)"
                >
                  <i class="fas fa-share"></i>&nbsp;&nbsp;&nbsp;Share To Social Media
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="hasReviseItemStatus(getCurrentStatus(data.status))"
                  @click="callProceedActionDialog('reviseItem', data.id)"
                >
                  <i class="fas fa-dot-circle"></i>&nbsp;&nbsp;&nbsp;Revise Item
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="hasRelistItemStatus(getCurrentStatus(data.status))"
                  @click="callProceedActionDialog('relistItem', data.id)"
                >
                  <i class="fas fa-undo"></i>&nbsp;&nbsp;&nbsp;Relist
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="hasCallToQueueStatus(getCurrentStatus(data.status))"
                  @click="callProceedActionDialog('callToQueue', data.id)"
                >
                  <i class="fas fa-undo"></i>&nbsp;&nbsp;&nbsp;Recall To Queue
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    hasEndListingStatus(getCurrentStatus(data.status)) &&
                    data.ebayId.length > 2
                  "
                  @click="callProceedActionDialog('endListing', data.id)"
                >
                  <i class="fas fa-times"></i>&nbsp;&nbsp;&nbsp;End Listing
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style scoped>
.b-table {
  background-color: rgba(0, 0, 0, 0.05);
  border: 5px solid #5b5f70;
}
</style>
<style>
.el-pagination.is-background .el-pager li,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next {
  border-radius: 20px !important;
  min-width: 34px;
  height: 32px;
  line-height: 34px;
}
.img-thumbnail {
  max-width: 110px;
  max-height: 110px;
}
</style>
